<template>
  
<div id="vy_body">
  <div id="vy_grid">
    <div id="vy_left_nav" class="p-4">
      <!--左サイドバー-->
      <ShakyoLeftbar v-on:call="call"/>
    </div>
    <div id="vy_main">
      <main>
  <div>
    <h2 class="kojin-title"><slot>{{ title }}</slot></h2>
  </div>
  
  <div id="manual_area">

    <span v-on:click="manual_open"><img class="m_icon" src="../../images/mark/manual.png"  />インポート画面のマニュアル</span>
    <span v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png"  />システムQ&A</span>

    </div>
    <br clear="all">
    <template v-if="inport_disp"> 
  <div align=center >
    <u>※ 昨年（2025年）度までのCSVファイルはご利用いただけません。</u><br>
    また、申込開始日以降になるとご利用いただけません。
    <table>
      <!--
      <tr>
        
        <td><h3 style="margin:0">年度を指定</h3></td>
        <td style="text-align: left;">
          <select v-model="disp_nendo">
            <option v-bind:value="(nendo-1)">{{ (nendo-1) }}</option>
            <option v-bind:value="nendo" >{{ nendo }}</option>
          </select>年度
        </td>
      </tr>
    
      <tr>
        <td><h3>事前説明会プログラムCSVファイル</h3></td>
        <td><input type='file' id="jizen_file" @change="jizenChange" accept=".csv"/></td>
      </tr>
      <tr>
        <td colspan=2 style="text-align: center;">
          <button type="submit" class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;" v-if="jizen_complete" v-on:click="inputJizen()" >入力する</button>
        
          <button type="submit" class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;;background-color: gray;"  v-else v-on:click="non_upload()" >入力する</button></td>
      </tr>
      <tr>
        <td><h3>事後集会プログラムCSVファイル</h3></td>
        <td><input type='file' id="jigo_file" @change="jigoChange" accept=".csv"/></td>
      </tr>
      <tr>
        <td colspan=2 style="text-align: center;">
          <button type="submit" class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;" v-if="jigo_complete" v-on:click="inputJigo()" >入力する</button>
        
          <button type="submit" class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;;background-color: gray;"  v-else v-on:click="non_upload()" >入力する</button></td>
      </tr>-->
      <tr>
        <td>
          <!--<h3>エクセルファイルをアップロードする</h3>-->
        </td>
        <td><input type='file' id="taiken_file" @change="fileUpload" accept=".xlsx"/></td>
      </tr>
      <tr>
        <td colspan=2 style="text-align: center;">
          <button type="submit" class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;"  v-if="taiken_complete" v-on:click="inputExcel()" >入力する</button>
          <button type="submit" class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;background-color: gray;"  v-else v-on:click="non_upload()" >入力する</button>
        </td>
      </tr>
    </table>
  </div><br/><br/>
  <div>
    入力処理後にエラーを含む処理結果が表示されます。<br/><br/>
    <textarea class="form-control enter_forcus" id="results_error" name="results_error" rows="100" style="width:100%"
     v-model="results_error"
         maxlength="5000"></textarea>
  </div>
  </template>
  <template v-else>

      ※申込開始日になったため、インポート機能はご利用いただけません。
    

    <!--
   新フォーマット対応のため、現在インポート機能はご利用いただけません。<br>
   今しばらくお待ちください。-->
  </template>
        <!--フッター-->
        <FooterArea v-on:call="call"/>
      </main>
    </div>
    <div id="vy_right_nav" class="p-4">
        <!--右サイドバー-->
        <ShakyoRightBar v-on:call="call"/>
    </div>
  </div>
</div>


    <!--メッセージを表示するモーダルウィンドウ-->
    <component v-bind:is="contentMessage"
              v-bind:message_text="message"
              v-bind:message_cat="message_cat"
              v-bind:message_flag="message_flag"
              @close_message="Close_message"
              @ok_message="OK_message"/>
              
</template>

<script setup>
/* eslint-disable */ 
import ShakyoLeftbar from './ShakyoLeftBar.vue'
import ShakyoRightBar from './ShakyoRightBar.vue'
import FooterArea from '../common/FooterArea.vue'
    import MessageModal from './ShakyoMessageModal.vue'
import { useRouter,useRoute } from 'vue-router'
import { GlobalData, login_check } from '../js/userdata_shakyo.js'
import AWS from 'aws-sdk';
//import {
//    CognitoUserPool,
//    CognitoUser,
//    AuthenticationDetails } from 'amazon-cognito-identity-js'
import { ref } from 'vue';
import { shallowRef, watch } from 'vue'
import axios from 'axios'
const url = GlobalData.$API_URL
//const fileInput = ref(null);
const router = useRouter()
const route = useRoute()

// エラーメッセージ（正常終了時もここに入力）
let results_error = ref("")

let title = "インポート"
GlobalData.shakyo = route.params.shakyo

// 締切フラグ　1:事業単位、2:プログラム単位
let end_shubetsu = 1;

let inport_disp = ref(false)

//---------------- 社協英名から市区町村コードと受付〆切日フラグ、申込開始日を取得
    axios.post(GlobalData.$API_URL+"Shakyo_read", 
        {shakyo:route.params.shakyo}
        ).then(response => {

            GlobalData.choson_code = response["data"].choson_code
            end_shubetsu = response["data"].end_shubetsu
            
            let moshikomi_date = new Date(response["data"].moshikomi_date+" "+response["data"].moshikomi_start)
            let today = new Date()
        
            moshikomi_date = moshikomi_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
            moshikomi_date = new Date(moshikomi_date);
            moshikomi_date.setHours(moshikomi_date.getHours());

            // 今日が申込開始日より前なら削除可能
            if (moshikomi_date > today) {
                inport_disp.value = true;
            }
     }).catch(error => {
          
     })

const prop = defineProps(['param'])
const emit = defineEmits(['call'])


// アップロード完了フラグ（このフラグが経つまで
let taiken_complete = ref(false)
let jizen_complete = ref(false)
let jigo_complete = ref(false)

// 今日の日付を取得
let set_date = new Date();
set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
set_date = new Date(set_date);
let nendo = ref(parseInt(set_date.getFullYear()))
let disp_nendo = ref(nendo.value)
login_check();

let upload_filename =""
let error_count  = 0
// ファイル取得 & Lambda へ送信
const fileUpload = async (e) => {

    // エラー初期化
    results_error.value = ""
    taiken_complete.value = false
    error_count = 0;

    const fileInput = e.target;
    const file = fileInput.files[0];
    if (!file) return;

    // 拡張子取得
    const accept = file.name.split(".").pop();

    // ファイル名作成
    const today = new Date();
    const fileNameOnly =
        `${GlobalData.shakyo}_${file.name.split(".")[0]}` +
        `_${today.getFullYear()}${today.getMonth()+1}${today.getDate()}` +
        `${today.getHours()}${today.getMinutes()}${today.getSeconds()}`;

    // アップロード先のフォルダを指定
    const folder = GlobalData.choson_code
    const file_name = `${folder}/${fileNameOnly}.${accept}`;

    // API側でファイル名を利用するので格納
    upload_filename = file_name

    // Lambda に送る payload
    const formData = new FormData();
    formData.append("file_name", file_name);
    formData.append("file", file);
    formData.append("Bucket",GlobalData.$CSV_bucket)

    try {
        // Lambda API Gateway の URL。APIGatewayではなくLambdaの関数URLを利用
        const set_url = GlobalData.$fileupload_url;

        // 呼び出し
        const response = await axios.post(set_url, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });

        console.log("Lambda response:", response.data);

        // アップロード完了フラグを立てる
        taiken_complete.value = true
    } catch (error) {
        console.error("Upload error:", error);
        error_count++;
    }
};

function non_upload(){
  alert("ファイルがアップロードされるまでお待ちください。")
}

let input_taiken_error = 0

function inputExcel() {
  results_error.value = "インポート中です。今しばらくお待ちください。"
    taiken_complete.value = false
    axios.post(url + "Excel_Import",
    {"choson_code":GlobalData.choson_code,
    "end_shubetsu":end_shubetsu,
    "filename":upload_filename})
      //ヘッダーを追加（IDトークンを送信）
    .then(response => {

      console.log(response)

        if(response.data.status == 0){
          // インポートが完了したら、体験プログラムの分類を設定する
//          results_error.value = "インポートが完了しました。"
          setupCategory(response.data.bunrui1,response.data.bunrui2)
        }else if(response.data.status == 1){
          results_error.value = "プログラムのエラーにより中断されました。"

        }else if(response.data.status == 2){
          results_error.value = response.data.message

        }
    })
    .catch(error => {
      if(input_taiken_error == 6){
        results_error.value = error + GlobalData.$axios_error;
      }else{
        input_taiken_error++
        setTimeout(function(){inputExcel()},"1000")
      }
    })
        document.getElementById("taiken_file").value = "";
}

function setupCategory(bunrui1,bunrui2){

  console.log(bunrui1)
  console.log(bunrui2)
  let set_bunrui = []
  for(var c = 0;c < bunrui1.length;c++){
    if(set_bunrui.length != 0){

      let set_zumi = 0 // 追加済みかどうか 0：まだ追加していない
      for(var b1 = 0;b1 < set_bunrui.length;b1++){

        // 名称が同じかつ種別が同じものがあれば追加済みとする
        if(bunrui1[c].name == set_bunrui[b1].name && bunrui1[c].shubetsu == set_bunrui[b1].shubetsu){
          set_zumi = 1
        }
      }

      if(set_zumi == 0){
        set_bunrui[set_bunrui.length] = {"name":bunrui1[c].name,"shubetsu":bunrui1[c].shubetsu,"bunrui":1,"bunrui1_name":null}
      }

    }else{
      set_bunrui[set_bunrui.length] = {"name":bunrui1[c].name,"shubetsu":bunrui1[c].shubetsu,"bunrui":1,"bunrui1_name":null}
    }

  }
  for(var c = 0;c < bunrui2.length;c++){

    if(bunrui2[c].name != "" && bunrui2[c].name != "None"){

      let set_zumi = 0 // 追加済みかどうか 0：まだ追加していない
      for(var b2 = 0;b2 < set_bunrui.length;b2++){
        // 名称・所属する分類1・種別が同じであれば追加済みとする
        if(bunrui2[c].name == set_bunrui[b2].name
          && bunrui2[c].bunrui1_name == set_bunrui[b2].bunrui1_name
          && bunrui2[c].shubetsu == set_bunrui[b2].shubetsu){
          set_zumi = 1
        }
      }

      if(set_zumi == 0){
        set_bunrui[set_bunrui.length] = {"name":bunrui2[c].name,"shubetsu":bunrui2[c].shubetsu,"bunrui":2,"bunrui1_name":bunrui2[c].bunrui1_name}
      }

    }
  }

    

  // 入力
  let update_array = "名称,種別,分類,分類１の名称\n" // １行目
    
  for(var c3 = 0;c3 < set_bunrui.length;c3++){
        // 編集した内容を保存する
        update_array += set_bunrui[c3]['name']+","
        update_array += parseInt(set_bunrui[c3]['shubetsu'])+","
        update_array += parseInt(set_bunrui[c3]['bunrui'])+","
        update_array += set_bunrui[c3]['bunrui1_name']+"\n"
  }

  
  //results_error.value = update_array
  categoryUpload(update_array)
}

// テンプレートのアップロード
    let csv_error_count = 0
    const categoryUpload = async (update_array) => {

        // エラー初期化
        csv_error_count = 0;

        let send_filname = GlobalData.shakyo+'/category.csv'

        // Lambda に送る payload
        const formData = new FormData();
        formData.append("file_name", send_filname);
        formData.append("file", update_array);
        formData.append("Bucket",GlobalData.$CSV_bucket)

        try {
            // Lambda API Gateway の URL。APIGatewayではなくLambdaの関数URLを利用
            const set_url = GlobalData.$fileupload_url;

            // 呼び出し
            const response = await axios.post(set_url, formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });

            console.log("Lambda response:", response.data);
            
          results_error.value = "データの登録が完了しました。"

        } catch (error) {
            console.error("Upload error:", error);
            csv_error_count++;
        }
    };

/*
let insert_taiken_count = 0
function insertTaiken(query,query2) {
    axios.post(url + "Taiken_insert",{"query_program":query,"query_nittei":query2,"choson_code":GlobalData.choson_code})  //ヘッダーを追加（IDトークンを送信）
    .then(response => {
        if(response.data.status == 0){
          results_error.value = "データの登録が完了しました。"
          
        }else if(response.data.status == 1){
          results_error.value = "入力プログラムのエラーにより、登録が中断されました。お手数ですが、さんこう株式会社までお問い合わせください。"

        }
    })
    .catch(error => {
        if(insert_taiken_count == 6){
          results_error.value = error + GlobalData.$axios_error;
        }else{
          insert_taiken_count++
          setTimeout(function(){insertTaiken(query,query2)},"1000")
        }
    })
}

let input_jizen_count = 0
function inputJizen() {
  const obj = document.getElementById('jizen_file');
  const jizen_file = document.getElementById("jizen_file").files[0]
  
  
  if(jizen_file != undefined){
    
    axios.post(url + "Jizen_csvCheck",{"nendo":disp_nendo.value,"choson_code":GlobalData.choson_code,"shakyo":GlobalData.shakyo,"filename":jizen_filename})
      //ヘッダーを追加（IDトークンを送信）
    .then(response => {
        obj.value = ''
        if(response.data.status == 0){
          const query = response.data.query
          insertJizen(query)
        }else if(response.data.status == 1){
          results_error.value = "プログラムのエラーにより中断されました。CSVファイルの文字コードをご確認ください。\n※文字コードは「SHIFT-JIS」に変更してください。"

        }else if(response.data.status == 2){
          results_error.value = response.data.error_text
        }
    })
    .catch(error => {
          
        if(input_jizen_count == 6){
          results_error.value = error + GlobalData.$axios_error;
        }else{
          input_jizen_count++
          setTimeout(function(){inputJizen()},"1000")
        }
    })
    jizen_complete.value = false
  }else{
    alert("アップロードするファイルを選択してください。")
  }
}

let insert_jizen_count = 0
function insertJizen(query) {
    axios.post(url + "Jizen_insert",{"query_jizen":query,"choson_code":GlobalData.choson_code})  //ヘッダーを追加（IDトークンを送信）
    .then(response => {
        if(response.data.status == 0){
          results_error.value = "データの登録が完了しました。"
          
        }else if(response.data.status == 1){
          results_error.value = "入力プログラムのエラーにより、登録が中断されました。お手数ですが、さんこう株式会社までお問い合わせください。"

        }
    })
    .catch(error => {
        if(insert_jizen_count == 6){
          results_error.value = error + GlobalData.$axios_error;
        }else{
          insert_jizen_count++
          setTimeout(function(){insertJizen(query)},"1000")
        }
    })
}

let input_jigo_count = 0
function inputJigo() {
  const obj = document.getElementById('jigo_file');
  const jigo_file = document.getElementById("jigo_file").files[0]
  
  
  if(jigo_file != undefined){
    
//    alert(nendo.value)
    axios.post(url + "Jigo_csvCheck",{"nendo":disp_nendo.value,"choson_code":GlobalData.choson_code,"shakyo":GlobalData.shakyo,"filename":jigo_filename})
      //ヘッダーを追加（IDトークンを送信）
    .then(response => {
        obj.value = ''
        if(response.data.status == 0){
          const query = response.data.query
          insertJigo(query)
        }else if(response.data.status == 1){
          results_error.value = "プログラムのエラーにより中断されました。CSVファイルの文字コードをご確認ください。\n※文字コードは「SHIFT-JIS」に変更してください。"

        }else if(response.data.status == 2){
          results_error.value = response.data.error_text
        }
    })
    .catch(error => {
      
        if(input_jigo_count == 6){
          results_error.value = error + GlobalData.$axios_error;
        }else{
          input_jigo_count++
          setTimeout(function(){inputJigo()},"1000")
        }
    })
    jigo_complete.value = false
  }else{
    alert("アップロードするファイルを選択してください。")
  }
}

let insert_jigo_count = 0
function insertJigo(query) {
    axios.post(url + "Jigo_insert",{"query_jigo":query,"choson_code":GlobalData.choson_code})  //ヘッダーを追加（IDトークンを送信）
    .then(response => {
        if(response.data.status == 0){
          results_error.value = "データの登録が完了しました。"
          
        }else if(response.data.status == 1){
          results_error.value = "入力プログラムのエラーにより、登録が中断されました。お手数ですが、さんこう株式会社までお問い合わせください。"

        }
    })
    .catch(error => {
        if(insert_jigo_count == 6){
          results_error.value = error + GlobalData.$axios_error;
        }else{
          insert_jigo_count++
          setTimeout(function(){insertJigo(query)},"1000")
        }
    })
}*/

let manual_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/1c1c0be34f8f80bbbc27f1ffe9816967"
    window.open(url,"_blank")
}

let qanda_open = function(){
    let url = "https://zest-newsprint-e3e.notion.site/Q-A-177c0be34f8f80f08c74c585be043e05"
    window.open(url,"_blank")

}

  /* メッセージを表示するモーダルウィンドウ */
  let message = ref("")//表示するメッセージ
  let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
  let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
  let message_flag = ref(false)//表示・非表示フラグ

  /* 表示する子コンポーネント関係の情報 */
  const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
  contentMessage.value = null // 表示する子コンポーネント
  
  //-------------- URLが変わった時に対応する処理を起動するためのフック -----------------
  const wt = watch(route, () => {
      param = { cmd:route.params.cmd, id:route.params.id }
      call(param)
  })
  
  //-------------- URLに応じた処理のコンポーネントを呼び出す -------------------
  const call = function(proc) {
  
      switch(proc.cmd) {
          case 'open_taikensha':
              // 子コンポーネント側（ShakyoRightBar）からの命令でウィンドウを開く
              
                message_cat.value = 2;
                message_flag.value = true;
                contentMessage.value = MessageModal
              break
          default:
              break
      }
  }
</script>
<style scoped>
td {border:none;text-align:right;padding:20px}
</style>
